import { render, staticRenderFns } from "./PackageMedicineConfig.vue?vue&type=template&id=7958917d&scoped=true"
import script from "./PackageMedicineConfig.vue?vue&type=script&lang=js"
export * from "./PackageMedicineConfig.vue?vue&type=script&lang=js"
import style0 from "./PackageMedicineConfig.vue?vue&type=style&index=0&id=7958917d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7958917d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7958917d')) {
      api.createRecord('7958917d', component.options)
    } else {
      api.reload('7958917d', component.options)
    }
    module.hot.accept("./PackageMedicineConfig.vue?vue&type=template&id=7958917d&scoped=true", function () {
      api.rerender('7958917d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Medicine/PackageMedicineConfig.vue"
export default component.exports